/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Default_CurrencyInputs */

const en_reference_field_default_currency = /** @type {(inputs: Reference_Field_Default_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default currency`)
};

/**
* | output |
* | --- |
* | "Default currency" |
*
* @param {Reference_Field_Default_CurrencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_default_currency = /** @type {((inputs?: Reference_Field_Default_CurrencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Default_CurrencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_default_currency(inputs)
});